export const VocabVocabVerificationPending = {
    'pro_pending_title': ['Validación de Cuenta en Proceso', 'Account Validation in Progress'],
    'pro_pending_description': [
        'Tu registro se ha completado con éxito. Actualmente, nuestro equipo está revisando la documentación proporcionada para activar tus funciones profesionales.',
        'Your registration was successful. Currently, our team is reviewing the documentation provided to activate your professional features.'
    ],
    'safety_compliance_note': [
        'Este proceso nos lleva alredoedor de X dias, esto para ayudarte a para cumplir con las normativas oficiales y garantizar tu seguridad y la de tus pacientes.',
        'This process is mandatory to comply with legal health regulations and ensure the safety of our patients.'
    ],
    'status_pending': ['En Revisión', 'Under Review'],
    'prepare_yourself': ['¡Prepárate para tu primer día!', 'Get ready for your first day!'],
    'manual_intro': [
        'Mientras validamos tu cédula, te recomendamos consultar el manual de usuario para que puedas comenzar a operar sin contratiempos.',
        'While we validate your license, we recommend checking the user manual so you can start operating smoothly.'
    ],
    'view_manual': ['Ver Manual Profesional', 'View Professional Manual'],
    'step_data_captured': ['Datos Recibidos', 'Data Received'],
    'step_license_review': ['Revisión de Cédula', 'License Review'],
    'step_ready': ['Perfil Activo', 'Profile Active'],
    'check_status_button': ['Actualizar Estado', 'Check Status'],
    'social_legend': ['Únete a nuestra comunidad', 'Join our community'],
};